export default __webpack_public_path__ + "static/NurseImg3-4c48c3540099fa09e692d18d2432e3f2.png";